// tslint:disable

import { get } from 'lodash';
import * as moment from 'moment';
import * as React from 'react';
import { FormLib } from '../../components/libs/form.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';

export class DefaultForm extends React.Component<any, any> {
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateForm(form);
        await this.executor.exec();
    }

    render() {
        return (
            <ResourceLoader entity="form" entityId={this.props.ENTITY_ID} render={(form: FormLib, raw: any) => <div>
                <LoaderComponent isLoading$={this.executor.loading$}/>
                <ToggleBoxComponent title={this.props.IS_CREATE ? '' : 'View Form'} color="green"
                                    alwaysOpen={true}>

                    <div className="row">
                        <div className="col-xs-6 col-sm-6 col-md-6">
                            <address>
                                <strong>{raw.companyName}</strong>
                                <br/>
                                {raw.firstName} {raw.lastName}
                                <br/>
                                {raw.email}
                            </address>
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-6 text-right">
                            <p>
                                <em>Date: {moment(get(raw, 'createdAt')).format('DD/MM/Y H:mm')}</em>
                            </p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                            <div style={{'textAlign': 'center'}}>
                                <h1>Questions and answers</h1>
                            </div>
                            <br/>
                            <table className="table table-bordered table-condensed table-striped">
                                <thead>
                                <tr>
                                    <th>Question</th>
                                    <th>Anser</th>
                                </tr>
                                </thead>
                                <tbody>

                                {[
                                    ...raw.formData.companyInformations,
                                    ...raw.formData.newZealand
                                ].map((value: any, ii: number) => <tr key={ii}>
                                    <td>{value.title}</td>
                                    <td>{value.answer}</td>
                                </tr>)}

                                </tbody>
                            </table>
                        </div>
                    </div>

                </ToggleBoxComponent>
            </div>}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/default.form.tsx